const features = [
  {
    icon: 'ri-4k-line',
    title: '高清画质',
    desc: '从720P到4K超清多档可选，最新影视资源画质始终在线，匹配不同网络环境，给你最佳视觉享受。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '流畅播放',
    desc: '智能CDN加速配合自研缓冲算法，最新电影不缓冲，最新电视剧流畅观看，告别转圈圈的痛苦体验。',
  },
  {
    icon: 'ri-refresh-line',
    title: '更新及时',
    desc: '专业内容团队7×24小时监测，热播剧集和院线电影上线当日即同步，最新更新快人一步。',
  },
  {
    icon: 'ri-money-cny-circle-line',
    title: '完全免费',
    desc: '坚持高清免费理念，所有影视资源无需付费、无需会员，在线观看零门槛，让好内容触手可及。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
              为什么选择丫丫影院
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              四大核心优势，重新定义你的在线观影体验
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {features.map((f) => (
              <div
                key={f.title}
                className="group p-6 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all duration-300"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100/80 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                  <i className={`${f.icon} text-xl`}></i>
                </div>
                <h3 className="text-base font-bold text-foreground-900 mb-2">{f.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}